import { useEffect, useState } from 'react';

export default function useInterval<T>({ callback, delay, dependency = undefined }: { callback: () => Promise<T> | undefined; delay: number; dependency?: unknown }) {
  const [data, setData] = useState<T | undefined>(undefined);

  useEffect(() => {
    let id: ReturnType<typeof setTimeout>;

    async function executeAndSetTimeout() {
      setData(await callback());
      id = setTimeout(executeAndSetTimeout, delay);
    }

    executeAndSetTimeout();

    return () => clearTimeout(id);
  }, [callback, delay]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setData(undefined);
  }, [dependency]);
  return [data];
}
